import {DisplayCommand, ScoreUpdate} from "../../javaTypes";
import {DisplayConfig} from "../Config";
import DisplayParams from "../DisplayParams";
import {useContext} from "react";

export default function Debug({command, config, scoreUpdate} : {
    command: DisplayCommand<any>,
    config: DisplayConfig,
    scoreUpdate?: DisplayCommand<ScoreUpdate>
}) {
    const params = useContext(DisplayParams)
    return <div style={{background: 'white', height: '100%', overflow: 'auto', textAlign: 'left'}}>
        <h1>Unbuilt component for: {command.type}</h1>
        <pre>
        {"\nConfig:\n"}
        {JSON.stringify(config, null, "\t")}
        {"\nCommand:\n"}
        {JSON.stringify(command, null, "\t")}
        {"\nScore update:\n"}
        {JSON.stringify(scoreUpdate, null, "\t")}
        </pre>
        <footer>
            Event {params.eventName}
        </footer>
    </div>
}